import InfiniteGlassMenuComponent from '../Common/InfiniteMenu/InfiniteGlassMenu';
import './ScreenSaver5.css';

import React, { useState,  useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import SplashCursor from '../Common/SplashCursor/SplashCursor';


//const logoCoppe         = require('../../assets/logo/coppe-white.png');
const screensaverVideo  = require('../../assets/video/screensaver_red.mp4');

// Carregar imagens PNG usando require
const eorImage = require('../../assets/logo/03/EOR.webp');
const cccImage = require('../../assets/logo/03/CCC.webp');
const ccusImage = require('../../assets/logo/03/CCUS.webp');
const eletrificationImage = require('../../assets/logo/03/Eletrificacao.webp');
const renovableEnergyImage = require('../../assets/logo/03/EnergiaRenovavel.webp');
const advancedManufacturingImage = require('../../assets/logo/03/MaterialAvancado.webp');
const ufrjLogo  = require('../../assets/logo/03/coppe-white.png');


const ScreenSaver5 = ({ onStart }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [splashKey, setSplashKey] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => { setIsVisible(true); }, 100); 
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSplashKey(prev => prev + 1);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const items = useMemo(() => [
    {
      icon: ufrjLogo, 
      link: `/presentation/eor/wag/Dubai`,
      title: 'CENTRO DE SOLUÇÃO DE BAIXO CARBONO DA COPPE',
      description: 'Transformação digital, Inteligência Artificial, Robótica, Manufatura auxiliada por computador e ciência computacional e engenharia.',
      isMainIcon: true
    },
    {
      icon: eorImage, 
      link: 'https://example.com/musica',
      title: 'SIM',
      description: 'FILMES',
      
    },
    {
      icon: cccImage, 
      link: 'https://example.com/filmes',
      title: 'Filmes',
      description: 'Explore nossa coleção de filmes'
    },
    {
      icon: ccusImage, 
      link: 'https://example.com/filmes',
      title: 'Filmes',
      description: 'Explore nossa coleção de filmes'
    },
    {
      icon: eletrificationImage, 
      link: 'https://example.com/filmes',
      title: 'Filmes',
      description: 'Explore nossa coleção de filmes'
    },
    
    {
      icon: renovableEnergyImage, 
      link: 'https://example.com/filmes',
      title: 'Filmes',
      description: 'Explore nossa coleção de filmes'
    },
    {
      icon: advancedManufacturingImage, 
      link: 'https://example.com/filmes',
      title: 'Filmes',
      description: 'Explore nossa coleção de filmes'
    }
  ], []);


  return (
    
    <div className={`screensaver5 ${isVisible ? 'fade-in' : ''} ${isFadingOut ? 'fade-out' : ''}`}>
      <div className="screensaver5-background">
      <img src={ufrjLogo} alt="Logo" style={{ marginLeft: '7rem', width: 'clamp(8rem, 20vw, 13rem)', height: 'auto' }} />
      
        <video 
          className="screensaver5-video" 
          autoPlay  
          muted 
          loop  
          playsInline 
          preload="metadata"
        >
        <source src={screensaverVideo} type="video/mp4" />
        </video>
        
      </div>
      
      
      <div className="screensaver5-content">
       
        <div className="screensaver5-hero-content">
            <div className="screensaver5-root">
              <InfiniteGlassMenuComponent items={items} enableShadow={true} />
            </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenSaver5;